/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  ChargePaymentResponse,
  ResendFailedNotificationResponse
} from '.././model';

import adminV1OrganizationsPaymentsScheduledPaymentsChargeCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsScheduledPaymentsResendFailedNotificationCreateMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * 
        Manually trigger a charge for an existing scheduled payment.

        This can be used to:
        - Charge a future payment early
        - Retry a failed payment
        - Force an immediate retry instead of waiting for the scheduled retry

        Only payments with status SCHEDULED, FAILED, or RETRY can be charged.
        Cash payments and already-processed payments cannot be charged.
        
 * @summary Charge a payment now
 */
export const adminV1OrganizationsPaymentsScheduledPaymentsChargeCreate = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsScheduledPaymentsChargeCreateMutator<ChargePaymentResponse>>,) => {
      return adminV1OrganizationsPaymentsScheduledPaymentsChargeCreateMutator<ChargePaymentResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/scheduled-payments/${id}/charge/`, method: 'POST'
    },
      options);
    }
  /**
 * Resend the payment declined email to the payer for a failed payment.
 * @summary Resend failed payment notification
 */
export const adminV1OrganizationsPaymentsScheduledPaymentsResendFailedNotificationCreate = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsScheduledPaymentsResendFailedNotificationCreateMutator<ResendFailedNotificationResponse>>,) => {
      return adminV1OrganizationsPaymentsScheduledPaymentsResendFailedNotificationCreateMutator<ResendFailedNotificationResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/scheduled-payments/${id}/resend-failed-notification/`, method: 'POST'
    },
      options);
    }
  export type AdminV1OrganizationsPaymentsScheduledPaymentsChargeCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsScheduledPaymentsChargeCreate>>>
export type AdminV1OrganizationsPaymentsScheduledPaymentsResendFailedNotificationCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsScheduledPaymentsResendFailedNotificationCreate>>>
